import { LicensePlateObjectFinder } from "Components/Form/LicensePlateObjectFinder";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import styled from "styled-components";

interface DescriptionProps {
  fw: number;
  size: string;
}

export const Description = styled.p<DescriptionProps>`
  font-size: ${({ size }) => size};
  font-style: normal;
  font-weight: ${({ fw }) => fw};
  line-height: 16px;
  margin: 10px 0;
`;

export const StyledLicensePlateObjectFinder = styled(LicensePlateObjectFinder)`
  margin-bottom: 32px;
`;

export const LinkButton = styled.a`
  margin-bottom: ${({ theme: { spacing } }) => spacing.md};
`;

export const AlertThemedButton = styled(ThemedButton)`
  align-self: flex-start;
  padding: 0;
`;

export const CarDescription = styled.div`
  display: flex;
  flex-direction: column;
`;
